var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatistic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_414",
    "data-name": "Group 414",
    transform: "translate(-218 -129)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_979",
    "data-name": "Rectangle 979",
    transform: "translate(218 138)",
    fill: "#fff",
    stroke: "#3a404e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 2.5,
    height: 10.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_980",
    "data-name": "Rectangle 980",
    transform: "translate(224 135)",
    fill: "#fff",
    stroke: "#3a404e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 2.5,
    height: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_981",
    "data-name": "Rectangle 981",
    transform: "translate(230 132)",
    fill: "#fff",
    stroke: "#3a404e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 2.5,
    height: 16.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_982",
    "data-name": "Rectangle 982",
    transform: "translate(236 129)",
    fill: "#fff",
    stroke: "#3a404e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 2.5,
    height: 19.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistic);
export default __webpack_public_path__ + "static/media/statistic.92abc2bd9fb5a891cbb7f65fa0b7b7a0.svg";
export { ForwardRef as ReactComponent };